import {
  Spacer,
  SidePanelDS,
  LockOutlined,
  TextCapitalized,
  Switch,
} from "@qivia/ui";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { t } from "i18next";
import { useCallback } from "react";
import styled from "styled-components";
import { updateDriverStatusAsync } from "../driversSlice";
import { useAppSelector, useAppDispatch } from "../../../../redux/hooks";
import { selectCompany } from "../../homeSlice";

export const UpdateDriverStatusSection = (props: {
  driverUuid: string;
  isDriverDelete: boolean;
  isDriverBlocked: boolean;
}) => {
  const company = useAppSelector(selectCompany);
  const dispatch = useAppDispatch();
  const { driverUuid, isDriverDelete, isDriverBlocked } = props;

  const updateDriverStatus = useCallback(
    (blockDriver: boolean, driverUuid: string) => {
      if (!company) return;
      void dispatch(
        updateDriverStatusAsync({
          driverUuid,
          status: blockDriver ? "BLOCKED" : "ACTIVE",
          companyUuid: company.uuid,
        }),
      );
    },
    [company, dispatch],
  );
  return (
    <SidePanelDS.ActionBlock>
      <SidePanelDS.SectionedActionStripe
        left={
          <StyledRowCenter>
            <LockOutlined />
            <Spacer x={0.25} />
            <TextCapitalized>{t("cards.sidePanel.lock")}</TextCapitalized>
          </StyledRowCenter>
        }
        right={
          <Switch
            onClick={() =>
              !isDriverDelete &&
              updateDriverStatus(!isDriverBlocked, driverUuid)
            }
            checked={isDriverBlocked || false}
            size={"S"}
            disabled={isDriverDelete}
          />
        }
      />
    </SidePanelDS.ActionBlock>
  );
};

const StyledRowCenter = styled.div`
  ${typographies["Body/S"]}
  display: flex;
  align-items: center;
  & svg {
    width: 1rem;
    height: 1rem;
  }
`;
